import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { isReportsPdfExport } from './reports.utils';

/** True when /reports was opened for PDF export (`printerFriendly` in the query string). */
export const useIsReportsPdfMode = (): boolean => {
  const { search } = useLocation();

  return useMemo(() => isReportsPdfExport(search), [search]);
};
